import PropTypes from 'prop-types';
import MKBox from 'components/MaterialKit/MKBox';
import MKTypography from 'components/MaterialKit/MKTypography';
import { useAuth } from 'contexts/auth';
import { useCallback, useEffect, useState } from 'react';
import { getLocaleMap } from 'utils/locales';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleErrorResponse } from 'utils/general';
import { Autocomplete, Dialog, DialogActions, DialogContent, Divider, InputBase, Paper, Tab, Tabs, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import moment from 'moment';
import DataTable from 'components/DataTable';
import { withLoading } from 'utils/hoc';
import isString from 'lodash/isString';
import get from 'lodash/get';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import some from 'lodash/some';
import cloneDeep from 'lodash/cloneDeep';
import sortedUniq from 'lodash/sortedUniq';
import escapeRegExp from 'lodash/escapeRegExp';
import getFp from 'lodash/fp/get';
import pickFp from 'lodash/fp/pick';
import CloseIcon from '@mui/icons-material/Close';
import Button from 'components/Button';
import Select from 'components/Select';
import { getData } from 'api/general';
import Image from 'components/Image';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { getBrands, getModels, getSources } from 'api/monitors';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import { getUserIWatchAccounts } from 'api/iwatch';
import { rawMessageIconColor } from 'utils/rawMessageIcon';
import { multiWordfilterOptions } from 'components/AutoComplete';
import { parsePhoneNumberFromString, ParseError } from 'libphonenumber-js/max';

const ContactDetailSection = ({ table_name, header_color, text_color, show_header, extra_params, refresh_second, page_options, sort_by_options, currency_options, source_options, setLoading, ...props }) => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentContactName = searchParams.get('contact_name');
  const currentContactNumber = searchParams.get('contact_number');
  const [formattedContactName, setFormattedContactName] = useState();
  const [pageSize, setPageSize] = useState(page_options?.length ? page_options[0] : 10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [keyword, setKeyword] = useState();
  const [rowsData, setRowsData] = useState([]);

  const [monitorTabValue, setMonitorTabValue] = useState('sell');
  const [conditionTabValue, setConditionTabValue] = useState('');
  const [product, setProduct] = useState();
  const [isProductDialogOpen, setIsProductDialogOpen] = useState(false);

  const [brandFilter, setBrandFilter] = useState('all');
  const [modelFilter, setModelFilter] = useState('');
  const [sourceFilter, setSourceFilter] = useState();
  const [currencyFilter, setCurrencyFilter] = useState();
  const [filterParams, setFilterParams] = useState({});

  const [sortByFilter, setSortByFilter] = useState('createddate');
  const [sortDirection, setSortDirection] = useState('desc');
  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);

  const [brandOptions, setBrandOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [accountKeys, setAccountKeys] = useState({});
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [sortByOptions, setSortByOptions] = useState([]);

  const [keywordOptions, setKeywordOptions] = useState([]);
  const [allModelOptions, setAllModelOptions] = useState([]);
  const [filterModelOptions, setFilterModelOptions] = useState([]);
  const [models, setModels] = useState([]);

  const [lm, setLm] = useState({});
  useEffect(() => {
    getLocaleMap([])
      .then((response) => {
        setLm(response);
      });
  }, []);

  const handleShowProductDetail = useCallback((data) => {
    setProduct(data);
    setIsProductDialogOpen(true);
  }, []);

  useEffect(() => {
    if (currentContactName) {
      // eslint-disable-next-line no-return-assign, no-param-reassign
      setFormattedContactName(currentContactName.split(/\s/).reduce((response, word) => response += word.slice(0, 1).toUpperCase(), '').slice(0, 2));
    }
  }, [currentContactName]);

  const columns = [
    {
      field: 'product_id',
      sortable: false,
      renderContent: (data) => {
        const { brand, model, description, condition, price, currency, image_url, contact_number, createddate, model_id, message_id, year, month, account } = data;

        const productTags = map(get(data, 'product_tags', []), 'tag');
        if (!some(productTags, (tag) => 'new' === tag || 'used' === tag)) {
          productTags.unshift(condition);
        }
        const modelIdName = get(model_id, 'id_name');
        const modelBrandName = get(model_id, 'brand_name');
        const contactNumber = get(contact_number, 'phone', contact_number);
        const whatsappMessage = `${monitorTabValue} ${modelIdName} ${currency} ${price?.toLocaleString()}`;
        const createddateMoment = moment(createddate);
        let messageDatetimeStr = null;
        const messageDatetime = data.datetime;
        if (messageDatetime != null) {
          const messageDatetimeMoment = moment(messageDatetime);
          const timeDiff = messageDatetimeMoment.diff(createddateMoment, 'minutes');
          if (Math.abs(timeDiff) >= 1) {
            messageDatetimeStr = messageDatetimeMoment.fromNow();
          }
        }
        return (
          <MKBox mb={1} padding="0.5rem" maxWidth="100%">
            <MKBox width="100%" padding={1} style={{ border: '1px solid lightgray' }} display="flex" flexDirection="column" onClick={() => handleShowProductDetail(data)}>
              <MKBox display="flex" flexDirection="column">
                <MKTypography mb={1} fontSize="16px" color={text_color}>
                  {modelIdName}
                </MKTypography>
                <MKTypography mb={1} fontSize="16px" color="gray">
                  {modelBrandName}
                </MKTypography>
              </MKBox>
              <Divider sx={{ bgcolor: 'gray', margin: 0, marginBottom: '1rem' }} />
              <MKBox display="flex">
                {/* <MKBox display="flex" flex={1} mr="1rem">
                  <Image src={image_url} width="100%" style={{ cursor: 'pointer' }} />
                </MKBox> */}
                <MKBox display="flex" flex={1} mr="1rem" flexDirection="column">
                  <Image src={image_url || model_id?.default_image?.file_url} width="100%" />
                  {message_id && (
                    <LibraryBooksOutlinedIcon
                      fontSize="medium"
                      style={{ cursor: 'pointer', color: rawMessageIconColor(accountKeys[account]) }}
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(`raw_message_details?id=${message_id}`, '_blank');
                      }}
                    />
                  )}
                </MKBox>
                <MKBox display="flex" flex={3} flexDirection="column" justifyContent="space-between">
                  <MKTypography mb={1} fontSize="16px" color={text_color}>
                    {description}
                  </MKTypography>
                  <MKBox display="flex">
                    {/*
                    {!(typeof condition !== 'string' || condition.length === 0) && (
                      <MKTypography fontSize="12px" color={text_color} padding="0.1rem 0.5rem" sx={{ backgroundColor: header_color, marginRight: '0.5rem' }}>
                        {condition.charAt(0).toUpperCase() + condition.slice(1)}
                      </MKTypography>
                    )}
                    {year && (
                      <MKTypography fontSize="12px" color={text_color} padding="0.1rem 0.5rem" sx={{ backgroundColor: header_color, marginRight: '0.5rem' }}>
                        {year}
                      </MKTypography>
                    )}
                    {month && (
                      <MKTypography fontSize="12px" color={text_color} padding="0.1rem 0.5rem" sx={{ backgroundColor: header_color, marginRight: '0.5rem' }}>
                        {month}
                      </MKTypography>
                    )}
                    */}
                    {productTags.map((tag) => {
                      return <MKTypography fontSize="12px" color={text_color} padding="0.1rem 0.5rem" sx={{ backgroundColor: header_color, marginRight: '0.5rem' }}>
                        {tag}
                      </MKTypography>
                    })}
                  </MKBox>

                </MKBox>
                <MKBox display="flex" flex={1.5} flexDirection="column" alignItems="flex-end">
                  <WhatsAppIcon
                    // fontSize="large"
                    style={{ cursor: 'pointer' }}
                    sx={{ fontSize: '3rem !important' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(`//api.whatsapp.com/send?phone=${encodeURIComponent(contactNumber)}&text=${encodeURIComponent(whatsappMessage)}`, '_blank')
                    }}
                  />
                  <MKTypography mb={1} fontSize="16px" color={text_color} fontWeight="bold" textAlign="right">
                    {`${currency} ${price?.toLocaleString()}`}
                  </MKTypography>
                  <MKTypography fontSize="14px" color="gray" textAlign="right">
                    {createddateMoment.fromNow()}
                  </MKTypography>
                </MKBox>
              </MKBox>
            </MKBox>
          </MKBox>
        );
      },
    },
  ];

  const fetchProductsFromApi = useCallback(() => {
    setLoading(true);
    const skip = currentPage * pageSize;
    const dataParams = {
      $expand: 'model_id/default_image,contact_number,product_tags',
      $orderBy: `${sortByFilter} ${sortDirection}`,
      $skip: skip,
      $top: pageSize,
      ...extra_params,
      // ...(keyword && { keyword }),
      ...filterParams,
      contact_number: currentContactNumber,
    };

    if (keyword) {
      let matchedModelIds;
      if (isString(keyword)) {
        const keywordPattern = new RegExp(escapeRegExp(keyword), 'i');
        matchedModelIds = filter(models, (model) => {
          const idName = model.id_name;
          return idName && keywordPattern.test(idName);
        }).map(getFp('model_id'));
      } else {
        matchedModelIds = [keyword.model_id];
      }

      let newModelIdAdded = false;

      const existingModelId = dataParams.model_id;
      if (existingModelId) {
        matchedModelIds.push(existingModelId);
        newModelIdAdded = true;
      }

      const existingModelIds = dataParams['model_id[in]'];
      if (existingModelIds) {
        const existingModelIdsArray = existingModelIds.split(',');
        if (existingModelIdsArray.length > 0) {
          Array.prototype.push.apply(matchedModelIds, existingModelIdsArray);
          newModelIdAdded = true;
        }
      }

      if (newModelIdAdded) {
        matchedModelIds.sort();
        matchedModelIds = sortedUniq(matchedModelIds);
      }

      if (matchedModelIds && matchedModelIds.length > 0) {
        dataParams['model_id[in]'] = matchedModelIds.join();
        delete dataParams.model_id;
      }
      if (dataParams['model_id[in]']) {
        delete dataParams['brand_id'];
      }
    }

    if (!dataParams.account && !dataParams['account[in]']) {
      const user_iwatch_accounts = auth?.user?.user_iwatch_accounts;
      if (user_iwatch_accounts && user_iwatch_accounts.length > 0) {
        const accountNames = user_iwatch_accounts.map(userIWatchAccount => userIWatchAccount?.iwatch_account?.name);
        dataParams['account[in]'] = accountNames.join();
      } else {
        dataParams['product_id[null]'] = true;
      }
    }

    dataParams.monitor_type = monitorTabValue;
    if (conditionTabValue) {
      dataParams.condition = conditionTabValue;
    }

    return getData(`/${table_name}`, dataParams, 'bearer')
      .then(({ data, headers }) => {
        const contentRange = get(headers, 'content-range');
        const size = Number(contentRange.split('/')[1]);
        setRowsData(data);
        setTotalRows(size);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setLoading, sortByFilter, sortDirection, currentPage, pageSize, extra_params, keyword, filterParams, currentContactNumber, monitorTabValue, conditionTabValue, table_name, setAuth]);

  const handleConfirmFilter = useCallback(() => {
    setIsFilterDialogOpen(false);

    let matchedModelIds = null;
    if (modelFilter) {
      if (isString(modelFilter)) {
        matchedModelIds = filter(models, (model) => {
          const idName = model.id_name;
          return idName && idName.includes(modelFilter);
        }).map(getFp('model_id'));
      } else {
        matchedModelIds = [modelFilter.model_id];
      }
    }

    const newFilteredParams = {};
    if (matchedModelIds && matchedModelIds.length > 0) {
      newFilteredParams['model_id[in]'] = matchedModelIds.join();
    }
    if (brandFilter && brandFilter !== 'all' && !newFilteredParams['model_id[in]']) {
      // only set brand filter if model is not set since these 2 values may not in sync
      // in some prodcuts
      const brand = brandOptions.find(brandOption => brandOption.value === brandFilter);
      const brandName = brand && brand.label;
      if (brandName && brandName.length > 0) {
        // newFilteredParams.brand = brandFilter;
        newFilteredParams['brand_id'] = brandFilter;
      }
    }
    if (currencyFilter && currencyFilter.length > 0) {
      newFilteredParams['currency[in]'] = currencyFilter.join();
    }
    if (sourceFilter && sourceFilter.length > 0) {
      newFilteredParams['account[in]'] = sourceFilter.join();
    }
    setFilterParams(newFilteredParams);
    setCurrentPage(0);
  }, [brandFilter, currencyFilter, modelFilter, sourceFilter]);

  const handleResetFilter = useCallback(() => {
    setIsFilterDialogOpen(false);
    setFilterParams({});
    setBrandFilter('all');
    setModelFilter('');
    setCurrencyFilter(null);
    setSourceFilter(null);
    setSortByFilter('createddate');
    setSortDirection('desc');
    setCurrentPage(0);
  }, []);

  const fetchBrandsFromApi = useCallback(() => {
    return getBrands()
      .then(({ data }) => {
        const options = data.map((datum) => ({
          // value: datum.name,
          value: datum.brand_id,
          label: datum.name,
        }));
        setBrandOptions([{ value: 'all', label: 'All' }, ...options]);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      })
      .finally(() => {
        // setLoading(false);
      });
  }, [setAuth]);

  const fetchModelsFromApi = useCallback(() => {
    return getModels({ $orderby: 'id_name' })
      .then(({ data }) => {
        const pickFn = pickFp(['model_id', 'id_code', 'id_name', 'brand_name', 'brand']);
        const newAllModelOptions = map(data, pickFn);
        const newKeywordOptions = cloneDeep(newAllModelOptions);
        setModels(data);
        setAllModelOptions(newAllModelOptions);
        setKeywordOptions(newKeywordOptions);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      })
      .finally(() => {
        // setLoading(false);
      });
  }, [setAuth]);

  const fetchSourcesFromApi = useCallback(() => {
    return getSources()
      .then(({ data }) => {
        setSourceOptions(data.map((datum) => {
          return {
            value: datum.name,
            label: datum.name,
          };
        }));
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      })
      .finally(() => {
        // setLoading(false);
      });
  }, [setAuth]);

  const fetchUserIWatchAccountsFromApi = useCallback(() => {
    if (!auth?.user) {
      return Promise.resolve();
    }
    return getUserIWatchAccounts({ $expand: 'iwatch_account', user: auth?.user?.username })
      .then(({ data }) => {
        const iWatchAccounts = sortBy(map(data, 'iwatch_account'), ['sequence']);
        setAccountKeys(iWatchAccounts.reduce((keys, iWatchAccount) => {
          return { ...keys, [iWatchAccount.name]: iWatchAccount.key };
        }, {}));
        const newSourceAccountOptions = map(iWatchAccounts, (iWatchAccount) => {
          const accountName = iWatchAccount.name;
          const phone = iWatchAccount.phone;
          try {
            const phoneNumber = parsePhoneNumberFromString('+' + phone);
            const formattedPhoneNumber = phoneNumber && phoneNumber.formatInternational() || phone;
            return {
              label: `${iWatchAccount.key} (${accountName}) (${formattedPhoneNumber})`,
              value: accountName,
            };
          } catch (e) {
            if (e instanceof ParseError) {
              // Not a phone number, non-existent country, etc.
              console.log(e.message);
            } else {
              throw e;
            }
          }
        });

        // newSourceAccountOptions.unshift({ label: '(none)', value: null });
        setSourceOptions(newSourceAccountOptions);
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [auth, setAuth]);

  useEffect(() => {
    fetchBrandsFromApi();
    fetchModelsFromApi();
    fetchUserIWatchAccountsFromApi();
  }, [fetchBrandsFromApi, fetchModelsFromApi, fetchUserIWatchAccountsFromApi]);

  useEffect(() => {
    if (currency_options) {
      setCurrencyOptions(currency_options);
    }
  }, [currency_options]);

  useEffect(() => {
    if (sort_by_options) {
      setSortByOptions(sort_by_options);
    }
  }, [sort_by_options]);

  // useEffect(() => {
  //   if (source_options) {
  //     setSourceOptions(source_options);
  //   }
  // }, [source_options]);

  const handleChangeSortDirection = useCallback(() => {
    setSortDirection((prevDirection) => (prevDirection === 'asc' ? 'desc' : 'asc'));
  }, []);

  const handleKeywordChange = (event, newValue) => {
    setKeyword(newValue);
    setCurrentPage(0);
  };

  useEffect(() => {
    if (table_name) {
      fetchProductsFromApi();
    }
  }, [fetchProductsFromApi, table_name]);

  const handleChangeMonitorTab = useCallback((event, newTabValue) => {
    setMonitorTabValue(newTabValue);
    if (newTabValue === 'buy') {
      setConditionTabValue('');
    }
  }, []);

  const handleChangeConditionTab = useCallback((event, newTabValue) => {
    setConditionTabValue(newTabValue);
  }, []);

  useEffect(() => {
    let newFilterModelOptions;
    if (brandFilter && brandFilter !== 'all') {
      newFilterModelOptions = filter(allModelOptions, ['brand', brandFilter]);
    } else {
      newFilterModelOptions = allModelOptions;
    }
    setFilterModelOptions(newFilterModelOptions);
  }, [brandFilter, allModelOptions]);

  return (
    <MKBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      {...props}
    >
      <MKBox
        display="flex"
        width="100%"
        flexDirection="column"
        alignItems="center"
        bgColor={header_color}
        padding="1rem"
      >
        <MKBox display="flex" width="100%">
          <ArrowBackIcon fontSize="medium" style={{ color: text_color, cursor: 'pointer' }} onClick={() => navigate(-1)} />
          <MKBox display="flex" alignItems="center" ml="1rem">
            <MKBox bgColor="#3259a1" color="white" display="flex" justifyContent="center" alignItems="center" padding={0.5} sx={{ borderRadius: '50%' }} width="50px" height="50px" mr="0.5rem">
              {formattedContactName}
            </MKBox>
            <MKBox display="flex" flexDirection="column">
              <MKTypography color={text_color}>
                {currentContactName && currentContactName.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())}
              </MKTypography>
              <MKTypography color={text_color}>
                {currentContactNumber}
              </MKTypography>
            </MKBox>
          </MKBox>
        </MKBox>
        <MKBox
          display="flex"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          marginY={1}
        >
          <MKBox display="flex" bgColor="white" width="100%" alignItems="center" style={{ borderRadius: 10 }}>
            <SearchIcon fontSize="medium" style={{ marginLeft: '1rem', marginRight: '1rem' }} />
            <Autocomplete
              freeSolo
              options={keywordOptions}
              value={keyword}
              fullWidth
              getOptionLabel={(option) => {
                if (typeof option === 'string') {
                  return option;
                }
                return `${option.id_name} (${option.brand_name}) (${option.id_code})`;
              }}
              onChange={handleKeywordChange}
              renderInput={(params) => {
                // eslint-disable-next-line no-param-reassign
                params.inputProps.style = { fontSize: '18px' };
                return (
                  <TextField
                    placeholder="Search by brand / model / code"
                    {...params}
                  />
                );
              }}
              filterOptions={multiWordfilterOptions}
            />
          </MKBox>
          <MKBox display="flex" alignItems="center" style={{ marginLeft: '1rem', cursor: 'pointer' }}>
            <FilterAltOutlinedIcon fontSize="medium" onClick={() => setIsFilterDialogOpen(true)} style={{ color: text_color }} />
            {sortDirection === 'asc'
              ? <KeyboardArrowUpIcon fontSize="small" onClick={handleChangeSortDirection} style={{ color: text_color }} />
              : <KeyboardArrowDownIcon fontSize="small" onClick={handleChangeSortDirection} style={{ color: text_color }} />}
          </MKBox>
        </MKBox>
      </MKBox>
      <MKBox display="flex" width="100%" alignItems="center">
        <MKBox width="100%" display="flex" flexDirection="column">
          <Tabs
            value={monitorTabValue}
            onChange={handleChangeMonitorTab}
            style={{ backgroundColor: 'transparent' }}
            TabIndicatorProps={{
              style: {
                backgroundColor: '#eacb38',
              },
            }}
            sx={{
              '.MuiButtonBase-root ': {
                color: `${text_color} !important`,
              },
            }}
          >
            <Tab value="sell" label="Sell" />
            <Tab value="buy" label="Wanted" />
          </Tabs>
          {monitorTabValue === 'sell' && (
            <MKBox>
              <MKBox px="1rem">
                <Divider style={{ backgroundColor: 'black' }} />
              </MKBox>
              <Tabs
                value={conditionTabValue}
                onChange={handleChangeConditionTab}
                style={{ backgroundColor: 'transparent' }}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: '#3259a1',
                  },
                }}
                sx={{
                  '.MuiButtonBase-root ': {
                    color: 'black !important',
                  },
                  '.Mui-selected': {
                    color: 'white !important',
                  },
                }}
              >
                <Tab value="" label="All" />
                <Tab value="new" label="New" />
                <Tab value="used" label="Used" />
              </Tabs>
            </MKBox>
          )}
        </MKBox>
      </MKBox>
      <MKBox display="flex" flexDirection="column" width="100%">
        <DataTable
          data={rowsData}
          columns={columns}
          showHeader={show_header}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          rowsPerPage={pageSize}
          rowsPerPageOptions={page_options}
          totalCount={/*totalRows*/ -1}
          onRowsPerPageChange={setPageSize}
        />
      </MKBox>
      <Dialog
        open={isFilterDialogOpen}
        fullWidth
      >
        <MKBox display="flex" width="100%" justifyContent="flex-end" padding={1}>
          <CloseIcon fontSize="medium" onClick={() => setIsFilterDialogOpen(false)} style={{ cursor: 'pointer' }} />
        </MKBox>
        <DialogContent>
          <MKTypography fontSize="16px" style={{ marginBottom: '0.25rem', marginTop: '1rem' }}>Source Feeder Account(s)</MKTypography>
          <Select
            value={sourceFilter}
            onChange={(v) => setSourceFilter(v)}
            options={sourceOptions}
            fullWidth
            multiple
            style={{ marginBottom: '1rem' }}
          />
          <MKTypography fontSize="16px" style={{ marginBottom: '0.25rem' }}>Brand</MKTypography>
          <Select
            value={brandFilter}
            onChange={(v) => {
              setBrandFilter(v);
              setModelFilter('');
            }}
            options={brandOptions}
            fullWidth
            style={{ marginBottom: '1rem' }}
          />
          <MKTypography fontSize="16px" style={{ marginBottom: '0.25rem' }}>Product</MKTypography>
          <Autocomplete
            freeSolo
            options={filterModelOptions}
            value={modelFilter}
            onChange={(event, newValue) => {
              setModelFilter(newValue);
            }}
            fullWidth
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              return `${option.id_name} (${option.id_code})`;
            }}
            renderInput={(params) => {
              // eslint-disable-next-line no-param-reassign
              params.inputProps.style = { fontSize: '14px', color: '#495057' };
              return (
                <TextField
                  {...params}
                />
              );
            }}
            filterOptions={multiWordfilterOptions}
          />
          <MKTypography fontSize="16px" style={{ marginBottom: '0.25rem' }}>Currency</MKTypography>
          <Select
            value={currencyFilter}
            onChange={(v) => setCurrencyFilter(v)}
            options={currencyOptions}
            fullWidth
            style={{ marginBottom: '1rem' }}
            multiple
          />
          <MKTypography fontSize="16px">Sort By</MKTypography>
          <Select
            value={sortByFilter}
            onChange={(v) => setSortByFilter(v)}
            options={sortByOptions}
            fullWidth
            style={{ marginBottom: '1rem' }}
          />
        </DialogContent>
        <DialogActions>
          <MKBox display="flex" width="100%" justifyContent="space-around">
            <Button fullWidth style={{ marginRight: '1rem', backgroundColor: 'white', borderColor: '1px solid black', color: 'black' }} onClick={handleResetFilter}>
              Reset
            </Button>
            <Button fullWidth style={{ backgroundColor: '#eacb37', color: 'black' }} onClick={handleConfirmFilter}>
              Confirm
            </Button>
          </MKBox>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isProductDialogOpen}
        fullWidth
      >
        {/* <MKBox display="flex" width="100%" justifyContent="flex-end" padding={1}>
          <CloseIcon fontSize="medium" onClick={() => setIsProductDialogOpen(false)} />
        </MKBox> */}
        <DialogContent style={{ display: 'flex', flexDirection: 'column' }}>
          <Image src={product?.image_url || product?.model_id?.default_image?.file_url} style={{ maxHeight: '50vh' }} />
          <MKTypography color={text_color} fontWeight="bold" textAlign="center" fontSize="16px">
            {product?.model_id?.id_name}
          </MKTypography>
          <MKTypography color={"gray"} textAlign="center" fontSize="16px">
            {product?.model_id?.brand_name}
          </MKTypography>
          <MKTypography color={text_color} textAlign="center" fontSize="16px">
            {product?.description}
          </MKTypography>
          <MKTypography color={text_color} textAlign="center" fontSize="16px">
            {`${product?.currency} ${product?.price?.toLocaleString()}`}
          </MKTypography>
          <Button fullWidth style={{ color: 'white', marginTop: '1rem' }} onClick={() => setIsProductDialogOpen(false)}>
            Close
          </Button>
        </DialogContent>
      </Dialog>
    </MKBox>
  );
};

ContactDetailSection.propTypes = {
  table_name: PropTypes.string,
  header_color: PropTypes.string,
  text_color: PropTypes.string,
  page_options: PropTypes.string,
  setLoading: PropTypes.func,
  show_header: PropTypes.bool,
  extra_params: PropTypes.object,
  refresh_second: PropTypes.number,
  sort_by_options: PropTypes.array,
  currency_options: PropTypes.array,
  source_options: PropTypes.array,
};

ContactDetailSection.defaultProps = {
  table_name: '',
  header_color: '#2c589d',
  text_color: '#000',
  page_options: [],
  setLoading: null,
  show_header: false,
  extra_params: {},
  refresh_second: 10,
  sort_by_options: [],
  currency_options: [],
  source_options: [],
};

export default withLoading(ContactDetailSection);
